/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationQuestionnaireAliases {
  DYNAMIC_FIELDS_QUESTIONNAIRE = 'dynamic-fields-questionnaire',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FETCH_QUESTIONNAIRE = 'fetch-questionnaire',
  FIELD_0 = 'field-0',
  FORM_0 = 'form-0',
  FORM_QUESTIONNAIRE = 'form-questionnaire',
  LAYOUT_0 = 'layout-0',
  MAPPER_0 = 'mapper-0',
  PANEL_PENDENCIES = 'panel-pendencies',
  PANEL_PROVIDER_ACCREDITATION_QUESTIONNAIRE = 'panel-provider-accreditation-questionnaire',
  PANEL_QUESTIONNAIRE = 'panel-questionnaire',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { ProviderAccreditationQuestionnaireAliases };
